"use client"

import type { I18nLocale } from "@/modules/i18n/types"
import type { FunctionComponent, PropsWithChildren } from "react"

import classNamesMaker from "classnames"

import { Button } from "@jobteaser/spark/components/Button"
import { BoltOutlined } from "@jobteaser/spark/components/Icons/BoltOutlined"

import { usePageLayoutContext } from "@/modules/jobAdDetail/components/PageLayout/PageLayoutContext"
import { SHORTLIST_STATUSES } from "@/modules/jobAdDetail/constants"
import { useJobAdDetailTracking } from "@/modules/jobAdDetail/hooks/useJobAdDetailTracking"

import styles from "./ApplyButton.module.css"

type InternalApplyButtonProps = PropsWithChildren<{
  applicationFlowIsEnabled: boolean
  baseUrl: string
  hasApplied: boolean
  isShortlisted: boolean
  locale: I18nLocale
  shortlistId: string
  unauthorizedLabel: string
}>

export const InternalApplyButton: FunctionComponent<InternalApplyButtonProps> = ({
  applicationFlowIsEnabled,
  baseUrl,
  children,
  hasApplied,
  isShortlisted,
  locale,
  shortlistId,
  unauthorizedLabel,
}) => {
  const { trackJobAdDetailApplyClick, trackEventClick } = useJobAdDetailTracking()
  const { openApplicationFlow } = usePageLayoutContext()

  const handleOnInternalApply = (): void => {
    if (hasApplied) {
      return
    }

    trackJobAdDetailApplyClick("internal", "job_ad_page")

    if (isShortlisted) {
      trackEventClick("shortlist_ad_apply_click")
      window.location.href = `${baseUrl}/${locale}/shortlists/candidate_statuses/update?shortlist_id=${shortlistId}&status=${SHORTLIST_STATUSES.OFFER_ACCEPTED}`
    } else {
      openApplicationFlow()
    }
  }

  return (
    <Button
      {...(!applicationFlowIsEnabled && {
        disabled: true,
        title: unauthorizedLabel,
      })}
      className={classNamesMaker(styles.main, { [styles.disabled]: hasApplied })}
      data-testid={
        isShortlisted
          ? "jobad-DetailView__CandidateActions__interested_internal_candidacy"
          : "jobad-DetailView__CandidateActions__Buttons_apply_internal_candidacy"
      }
      icon={isShortlisted ? undefined : BoltOutlined}
      onClick={handleOnInternalApply}
      variant="highlight"
    >
      {children}
    </Button>
  )
}
